if (!window.atelierNavigationReady) {
  window.atelierNavigationReady = true;
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.altform-restored__mobile-menu[open]').forEach((menu) => {
      if (!menu.contains(event.target) || event.target.closest('nav a')) menu.open = false;
    });
    document.querySelectorAll('.altform-nav__group[open]').forEach((group) => {
      if (!group.contains(event.target) || event.target.closest('a')) group.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.altform-restored__mobile-menu[open]').forEach((menu) => {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
    document.querySelectorAll('.altform-nav__group[open]').forEach((group) => {
      group.open = false;
      group.querySelector('summary').focus();
    });
  });
}
